import { lazy } from 'react';
import { Route } from '@greenkub-fronts/shared/router';

const DashboardLayoutFeature = lazy(() =>
  import('../feature/dashboard-layout-feature/dashboard-layout-feature').then(
    ({ DashboardLayoutFeature }) => ({
      default: DashboardLayoutFeature,
    })
  )
);

const OldProjectsFeature = lazy(() =>
  import('../feature/old-projects-feature/old-projects-feature').then(
    ({ OldProjectsFeature }) => ({
      default: OldProjectsFeature,
    })
  )
);

const CustomerChatFeature = lazy(() =>
  import('../feature/customer-chat-feature/customer-chat-feature').then(
    ({ CustomerChatFeature }) => ({
      default: CustomerChatFeature,
    })
  )
);

const CustomerDocumentSpaceFeature = lazy(() =>
  import(
    '../feature/customer-document-space-feature/customer-document-space-feature'
  ).then(({ CustomerDocumentSpaceFeature }) => ({
    default: CustomerDocumentSpaceFeature,
  }))
);

export const ROUTER_CUSTOMER_AREA: Route[] = [
  {
    path: '/document/*',
    component: <CustomerDocumentSpaceFeature />,
  },
  {
    path: '/chat',
    component: <CustomerChatFeature />,
  },
  {
    path: '/anciens-projets',
    component: <OldProjectsFeature />,
  },
  {
    path: '',
    component: <DashboardLayoutFeature />,
  },
];
